<template>
    <component :is="tag" ref="host">
        <teleport :to="shadowRoot" v-if="shadowRoot">
            <slot />
        </teleport>
        <slot v-else />
    </component>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';

    defineOptions({
        name: 'ShadowRoot',
    });

    withDefaults(
        defineProps<{
            tag?: string;
        }>(),
        {
            tag: 'div',
        }
    );

    const host = ref<HTMLElement | null>(null);
    const shadowRoot = ref<ShadowRoot | null>(null);

    onMounted(() => {
        const hostEl = host.value;
        if (!hostEl || !hostEl.attachShadow) {
            return;
        }

        shadowRoot.value = hostEl.attachShadow({ mode: 'open' });
    });
</script>
